import React from 'react';
import { Redirect } from 'react-router-dom';

import { MilestonesTab } from 'app/pages/system/loanProgressMilestones/LoanProgressMilestonesPage.constants';

import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export const LOAN_PROGRESS_MILESTONES_PARAMS = {
  tab: 'tab',
};

export class LoanProgressMilestonesPaths {
  static loanProgressMilestones = new EnhancedPath('/loan-progress-milestones');
  static loanProgressMilestonesTab = new EnhancedPath(
    `${LoanProgressMilestonesPaths.loanProgressMilestones.path}/:${LOAN_PROGRESS_MILESTONES_PARAMS.tab}?`,
  );
  static consequentMilestones = new EnhancedPath('/consequent-milestones');
  static permanentMilestones = new EnhancedPath('/permanent-milestones');
}

const ConsequentMilestonesRedirect = () => (
  <Redirect
    to={LoanProgressMilestonesPaths.loanProgressMilestonesTab.generatePath({
      [LOAN_PROGRESS_MILESTONES_PARAMS.tab]: MilestonesTab.CONSEQUENT,
    })}
  />
);

const PermanentMilestonesRedirect = () => (
  <Redirect
    to={LoanProgressMilestonesPaths.loanProgressMilestonesTab.generatePath({
      [LOAN_PROGRESS_MILESTONES_PARAMS.tab]: MilestonesTab.PERMANENT,
    })}
  />
);

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: LoanProgressMilestonesPaths.loanProgressMilestonesTab.path,
      component: lazyWithRetry(() => import('app/pages/system/loanProgressMilestones')),
      pageCode: PAGE_CODES.MANAGE_LOAN_FLOW_MILESTONES,
    },
    {
      path: LoanProgressMilestonesPaths.consequentMilestones.path,
      component: ConsequentMilestonesRedirect,
      pageCode: PAGE_CODES.MANAGE_LOAN_FLOW_MILESTONES,
    },
    {
      path: LoanProgressMilestonesPaths.permanentMilestones.path,
      component: PermanentMilestonesRedirect,
      pageCode: PAGE_CODES.MANAGE_LOAN_FLOW_MILESTONES,
    },
  ],
};

export default routesConfig;
